import React, { ReactNode } from 'react';

interface CardProps {
    children: ReactNode;
    className?: string;
}

export const Card = ({ className, children }: CardProps) => <div className={`card-wrap rd-32 shadow1 p28 ${className}`}>{children}</div>;
